import { Link } from 'react-router-dom';
import LanguageSelector from './LanguageSelector';
import PublicServicesMenu from '@/components/navigation/PublicServicesMenu';
import PublicFaqSupportLinks from '@/components/navigation/PublicFaqSupportLinks';
import { useBranding } from '@/hooks/useBranding';

const PublicHeader = () => {
  const { brandName } = useBranding();

  return (
    <header className="sticky top-0 z-40 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link
            to="/"
            className="flex items-center space-x-2 min-w-0 flex-1 hover:opacity-80 transition-opacity"
          >
            <img
              src="/qls-logo-nav.webp"
              alt="QLS Logo"
              className="w-8 h-8 object-contain flex-shrink-0"
              width="32"
              height="32"
            />
            <h1 className="text-lg sm:text-xl font-bold text-accent truncate">{brandName}</h1>
          </Link>
          <div className="flex items-center space-x-2 sm:space-x-3 flex-shrink-0">
            {/* Address search is worldwide; country is chosen in Services when needed. */}
            <PublicServicesMenu />
            <Link
              to="/get-app"
              className="text-gray-600 hover:text-emerald-600 transition-colors font-medium text-sm sm:text-base min-h-[44px] flex items-center px-2 py-2 rounded-md"
            >
              Get the app
            </Link>
            <PublicFaqSupportLinks />
            <div className="scale-75 sm:scale-100 origin-right">
              <LanguageSelector />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;
